<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      addText=""
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList" ></storeListSelect>
          </div>
          <div class="queryItem" >
            <label>创建日期:</label>
            <timeStampDatePicker class="item" v-model="query.duration" type='daterange' clearable>
            </timeStampDatePicker>
        </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <!-- v-if="handlePermission('addActivityCollection')" -->
        <div class="btn-wrap" v-if="handlePermission('checkInvoiceRate')">
          <lk-button class="mb8" type="primary"  @click="addNew">发票税率核对</lk-button>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
    <lk-modal
      v-model="showConfigModal"
      title="发票税率核对"
      width="390px"
      :footer-hide='true'
      :mask-closable="false"
      @on-ok="toUpload"
      @on-cancel="toCancel"
    >
      <div class="uploadContent">
        <div class="titleM">
          <div class="titleT">核对门店：</div>
          <storeListSelect v-model="storeId" :multiple="canMutable" filterable clearable style="width: 220px !important;"></storeListSelect>
        </div>
        <div class="titleM">
          <div class="titleT">导入明细：</div>
          <div style="width: 227px">
            <div class="uploader" @click="$refs.file.click()">
              <input type="file" ref="file" @change="fileReader" v-show="false">
              <div style="margin-top: 8px; color: #1890FF">{{ this.file ? `${this.file.name || ''}` : '上传文件...' }}</div>
              <div style="margin-top:6px;">请上传对应门店税控系统导出的开票明细</div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-left: 220px; margin-top: 10px;">
        <lk-button @click="toCancel" class="cancel">取消</lk-button>
        <lk-button type='primary' @click="toUpload">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inputSearch from '../../components/InputSearch.vue';
import tools from '../../services/tools';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'invoiceRate',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    inputSearch,
  },
  data() {
    return {
      storeId: [],
      showConfigModal: false,
      file: '',
      canMutable: true,
      query: {
        storeIdList: [],
      },
      columns: [
        {
          title: ' ',
          width: 50,
          type: 'index',
        },
        {
          title: '门店名称',
          width: 180,
          key: 'storeName',
        },
        {
          title: '处理状态',
          width: 90,
          key: 'statusName',
        },
        {
          title: '发票日期范围',
          width: 180,
          key: 'invoiceDateRange',
        },
        {
          title: '核对结果',
          minWidth: 116,
          key: 'verifyResult',
          render: (h, params) => h('div', [h('span', params.row.verifyResult), h('br'), h('span', params.row.verifyResultDetail)]),
        },
        {
          title: '创建人',
          width: 116,
          key: 'createUserName',
        },
        {
          title: '创建时间',
          width: 170,
          key: 'createTime',
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('invoiceRateDetail') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: params.row.status !== 2,
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'invoiceRateDetail', params: { id: params.row.id, time: params.row.dayTime, storeName: params.row.storeName } });
                },
              },
            }, '查看') : null,
            this.handlePermission('invoiceRateDetail') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: params.row.status !== 2,
              },
              on: {
                click: () => {
                  this.downloadResult(params.row.id, params.row.storeName, params.row.dayTime);
                },
              },
            }, '下载结果') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    clear() {
      this.page = 1;
      this.size = 20;
      this.query = {
        storeIdList: [],
        duration: [],
      };
    },
    fileReader(e) {
      this.file = e.target.files[0];
      e.target.value = null;
    },
    toUpload() {
      if (this.storeId == '' || !this.storeId) {
        this.$Message.error('请选择门店');
        return;
      }
      if (this.file == '') {
        this.$Message.error('请选择上传文件');
        return;
      }
      const form = new FormData();
      form.append('file', this.file);
      form.append('storeId', this.storeId);
      tools.verifySubmit(form).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('上传成功');
          this.getData();
          this.resetModel();
        } else {
          this.resetModel();
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    resetModel() {
      this.getData();
      this.toCancel();
    },
    toCancel() {
      this.file = '';
      this.showConfigModal = false;
      this.storeId = '';
    },
    addNew() {
      this.showConfigModal = true;
    },
    downloadResult(value, storeName, time) {
      tools.verifyDownload({ verifyId: value }).then((res) => {
        utils.downLoadExcel(res, `发票税率核对${storeName}${time}.xlsx`, true);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      const params = {
        storeIdList: this.query.storeIdList,
      };
      if (this.query.duration) {
        params.createTimeStart = this.query.duration[0];
        params.createTimeEnd = this.query.duration[1];
      }
      params.page = this.page;
      params.size = this.size;
      tools.verifyList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = item;
            item.dayTime = utils.exchangeTime(item.createTime);
            item.createTime = utils.exchangeTimeToSecond(item.createTime);
            this.tableData.push(result);
          });
        } else {
          this.tableData = [];
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.tableData = [];
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
  .btn-cont {
    display: flex;
    margin-top: 16px;
    justify-content: flex-end;
  }
  .uploadContent {
    display:flex;
    flex-direction:column;
    align-items: flex-start;
  }
  .titleM {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;
  }
  .titleT {
    margin-top: 8px;
    font-weight: 500;
    width: 60px;
  }

  .cancel{
    margin-right: 16px
  }
</style>
